export const getVaultPerformanceColorClass = (performance: number) => {
  if (performance > 0) {
    return 'text-green';
  }

  if (performance < 0) {
    return 'text-red-500';
  }

  return 'text-white-500';
};
